export type SortFilterItem = {
  reverse: boolean
  slug: null | string
  title: string
}

export const defaultSort: SortFilterItem = {
  slug: null,
  reverse: false,
  title: 'По алфавиту',
}

export const sorting: SortFilterItem[] = [
  defaultSort,
  { slug: '-createdAt', reverse: true, title: 'Сначала новые' },
  { slug: 'priceFrom', reverse: false, title: 'Сначала дешевле' }, // asc
  { slug: '-priceFrom', reverse: true, title: 'Сначала дороже' },
]

/** Личные кабинеты покупателей — следующий этап. Роуты закрыты в redirects.ts. */
export const ACCOUNTS_ENABLED = false
